
import React from 'react';
export default function Blog004() {
  return (
    <section>
    <article>
      <h2>4. 08-10-2022</h2>
      <h3>Learning Javascript</h3>
      <p>
        I have a concept for a text game. I outlined my idea in an earlier blog post. This project is a bit ambitious, but absolutely within possibility. It will be a great milestone marker for progress made with Javascript.  I have received help on the first part of the game in javascript. I am currently stuck, which is a perfect learning experience and hard reason to push forward with  learning. I am going to focus on learning Javascript to take the next step with this project. 
<br /><br /><br />
I am currently reading The ‘Gamers Guide to CODING’ by Gordon McComb. This book covers Javascript and presents it in a fun way. I am also using online learning resources like WarriorJS and Codewars.  
<br />
I am currently reading ‘Learn to Code. Get a Job’ by Gwendolyn Faraday. She suggests writing out your goals as a reminder to yourself when times are hard. I have written a list of goals by year for organization and motivation. This was a great suggestion.
<br />
I have written out a daily schedule plan, this is great for keeping on task.  I am revising it today, as it states on said schedule. Another great suggestion from Gwendolyn. 
<br /><br /><br />
I have also recorded my week 5 blog. I highlight some of the resources I have been using, some of my creations, and where I plan to go in the near future. I added a link to the video at the bottom of this post.
<br />


      </p> 
    </article>
  
    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://www.youtube.com/watch?v=hHKFmBqIjoU"
          title="Week 5 VLOG"
        >
          <strong><p>Week 5 VLOG</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
